import Cookies from 'js-cookie'

const isProd = process.env.NODE_ENV === 'production';

const ACCESS_TOKEN_KEY = 'spree_access_token';
const REFRESH_TOKEN_KEY = 'spree_refresh_token';

export const getUserToken = () => Cookies.get(ACCESS_TOKEN_KEY);
export const getRefreshToken = () => Cookies.get(REFRESH_TOKEN_KEY);

export const setUserToken = (access_token, refresh_token, expires_in = 86400) => {
  const expirationDays = expires_in / 86400;
  Cookies.set(ACCESS_TOKEN_KEY, access_token, { expires: expirationDays, secure: isProd, sameSite: 'Strict' });
  Cookies.set(REFRESH_TOKEN_KEY, refresh_token, { expires: 1, secure: isProd, sameSite: 'Strict' });
}

export const clearUserToken = () => {
  Cookies.remove(ACCESS_TOKEN_KEY);
  Cookies.remove(REFRESH_TOKEN_KEY);
}

export const isUserLoggedIn = () => {
  return !!getUserToken();
}